exports = module.exports = require("../../../../../../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend-diy/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".outcome-job[data-v-aa91ca00]{padding:14px 0;border-bottom:1px solid #e3ebed;margin-bottom:12px}.outcome-job-form[data-v-aa91ca00]{background:#f5f8f8;border-radius:10px;padding:14px;margin-top:14px}.outcome-job-form h4[data-v-aa91ca00]{margin:0}.outcome-job ul[data-v-aa91ca00]{padding-left:18px;font-size:12px}", ""]);

// exports
